import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'accent' | 'ghost';
type Size = 'md' | 'lg';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  icon?: ReactNode | false;
  pill?: boolean;
}

const variantClass: Record<Variant, string> = {
  primary: 'bg-fg text-bg hover:opacity-90 active:opacity-80',
  accent: 'bg-accent text-fg hover:brightness-95 active:brightness-90',
  ghost: 'bg-transparent text-fg border border-line hover:bg-bg-2',
};

const sizeClass: Record<Size, string> = {
  md: 'px-5 py-3 text-[15px]',
  lg: 'px-6 py-4 text-base',
};

export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  icon = '→',
  pill = false,
  className = '',
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={[
        'inline-flex items-center justify-center gap-2.5 font-medium transition select-none disabled:opacity-50 disabled:cursor-not-allowed',
        variantClass[variant],
        sizeClass[size],
        pill ? 'rounded-full' : 'rounded-lg',
        className,
      ].join(' ')}
    >
      <span>{children}</span>
      {icon !== false && icon != null && <span className="text-lg leading-none">{icon}</span>}
    </button>
  );
}
